import React from 'react';
import { Box } from '../../base/Box/Box';
import { FeaturedCompaniesGridSectionStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';
import { tw } from 'classname-variants';
import classNames from 'classnames';

export const FeaturedCompaniesGridSection = ({
  subheading,
  heading,
  cards,
  colourScheme = 'white',
  overlayOverBkg,
}: FeaturedCompaniesGridSectionStoryblok) => {
  if (!subheading && !heading && !cards) {
    return null;
  }

  const initialCards = cards?.slice(0, 3);
  const remainingCards = cards?.slice(3, cards?.length);

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box as="div" className="mx-auto max-w-standard">
        <Type as="h3" typography="subheading">
          {subheading}
        </Type>
        <Type as="h2" className="text-h2">
          {heading}
        </Type>
        <Box
          as="div"
          className="md:grid-row-2 mt-10 grid grid-cols-1 gap-6 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 "
        >
          {renderStoryblokComponents({
            blocks: initialCards,
            childClassName: classNames(
              // First block
              tw`xs:first:col-span-2 xs:first:aspect-[2/1] md:first:aspect-square md:first:col-span-1 md:first:row-span-2 lg:first:col-span-2`,
              // Second and third blocks
              tw`aspect-square col-span-1 row-span-2 xs:col-span-1 md:col-span-2 md:row-span-1 md:aspect-auto lg:col-span-3`
            ),
          })}
        </Box>
        <Box
          as="div"
          className="mt-6 grid grid-cols-1 gap-6 xs:grid-cols-2 md:grid-cols-3"
        >
          {renderStoryblokComponents({
            blocks: remainingCards,
            childClassName: classNames(tw`aspect-square`),
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default FeaturedCompaniesGridSection;
